import styled from 'styled-components'
import { sv } from '@ucheba/utils/helpers/styles/variables'

const Block = styled.li<{ isDivider?: boolean }>`
  padding-top: ${sv.spacing.xlarge};
  padding-bottom: ${sv.spacing.xlarge};
  border-top: 1px solid ${sv.color.gray9};
`

export default { Block }
